import { render, staticRenderFns } from "./PushSelectedWordpress.vue?vue&type=template&id=52cb0ce3&"
import script from "./PushSelectedWordpress.vue?vue&type=script&lang=ts&"
export * from "./PushSelectedWordpress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports